export default "__VITE_ASSET__CURQW1Nf__"